import {
  ScenarioExportable,
  ScenarioReportType,
} from 'spw-redux/modules/reports/types';

export const REPORT_TYPES: {
  [key: string]: ScenarioReportType;
} = {
  WORKSHEET: 'worksheet',
  WORKSHEET_WITH_NOTES: 'worksheetWithNotes',
  WORKSHEET_AND_SUMMARY_CALCULATIONS: 'worksheetAndSummaryCalculations',
  PROGRAM_SUMMARY: 'programSummary',
  PROGRAM_SUMMARY_ONE_PAGER: 'programSummaryOnePager',
  SEAT_COUNT_ANALYSIS: 'seatCountAnalysis',
  SUMMARY_CALCULATIONS: 'summaryCalculations',
  NOTES_BY_CATEGORY: 'notesByCategory',
  ALL_NOTES: 'allNotes',
};

export const SCENARIO_EXPORTABLE: { [key: string]: ScenarioExportable } = {
  WORKSHEET: 'worksheet',
  PROGRAM_SUMMARY: 'programSummary',
  PROGRAM_SUMMARY_ONE_PAGER: 'programSummaryOnePager',
  SUMMARY_CALCULATIONS: 'summaryCalculations',
  SEAT_COUNT_ANALYSIS: 'seatCountAnalysis',
  PROGRAM_NOTES: 'notes',
};

export enum ProgramSummaryExportableTypes {
  ALL_CARDS_INDIVIDUALLY = 'allCardsIndividually',
  ONE_PAGER = 'onePager',
  SUMMARY_DATA = 'summaryData',
}
